// app/javascript/projects/components/ProjectsDisplay.jsx
import React from 'react';
import SurveyHeader from './SurveyHeader';
import ProjectHeader from './ProjectHeader'
import AnalysisHeader from './AnalysisHeader'
import CodesHeader from './CodesHeader'
import ShareHeader from './ShareHeader'
import ErrorAlert from '../ErrorAlert'
import Header from './Header'
import ChatHeader from './ChatHeader'
import TranscriptHeaderContainer from './TranscriptHeaderContainer';
import { useProject } from '../../../hooks/projects/queries';
import { useCurrentProject } from '../../../hooks/projects/useCurrentProject';
import { useProjectWithErrorHandling } from '../../../hooks/projects/useProjectWithErrorHandling';
import { isProjectArchived } from '../../../utils/projectUtils';

import {
  Switch,
  Route,
} from 'react-router-dom'

function QualHeader(props) {
  const { projectId } = useCurrentProject();
  const { data: project } = useProject(projectId);
  const { hasError } = useProjectWithErrorHandling(projectId);
  
  // Determine if project is active
  const isActiveValue = !project || project.is_active === undefined || project.is_active;
  
  // Show basic header for archived projects or error states
  if (hasError || !projectId || isProjectArchived(project)) {
    return (
      <div className='header'>
        <ErrorAlert/>
        <Header></Header>
      </div>
    );
  }
  
  return (
    <div className='header'>
      <ErrorAlert/>
      <Switch>
        <Route
          path='/projects/:projectID/transcripts/new'
          render={() => (
            <ShareHeader hasEditPermission={props.hasEditPermission}>
              Add Transcript
            </ShareHeader>
          )}
        />
        <Route
          path='/projects/:projectID/surveys/new/:csvID'
          render={() => (<Header>Add Survey</Header>)}
        />
        <Route
          path='/projects/:projectID/surveys/new'
          render={() => (
            <ShareHeader hasEditPermission={props.hasEditPermission}>
              Add Survey
            </ShareHeader>
          )}
        />
        <Route
          path='/projects/:projectID/search'
          render={() => (
            <ShareHeader hasEditPermission={props.hasEditPermission} name="Search">
              Search
            </ShareHeader>
          )}
        />
        <Route
          path='/projects/:projectID/chat'
          render={() => (
            <ChatHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/projects/:projectID/reports'
          render={() => (<Header>Exports and Reports</Header>)}
        />
        <Route
          exact
          path='/projects/:projectID/transcripts'
          render={() => (
            <ShareHeader hasEditPermission={props.hasEditPermission} name="Transcripts">
              Transcripts
            </ShareHeader>
          )}
        />
        <Route
          path='/projects/:projectID/analysis'
          render={() => (
            <AnalysisHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
          exact
        />
        <Route
          path='/projects/:projectID/codes'
          render={() => (
            <CodesHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/projects/:projectID'
          render={() => (
            <ProjectHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/transcripts/:transcriptID'
          render={() => (
            <TranscriptHeaderContainer
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/surveys/:surveyID'
          render={() => (
            <SurveyHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/survey_responses/:surveyResponseID'
          render={() => (
            <SurveyHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/survey_questions/:surveyQuestionID'
          render={() => (
            <SurveyHeader
              hasEditPermission={props.hasEditPermission}
              isActive={isActiveValue}
              roleIsEdit={props.roleIsEdit}
            />
          )}
        />
        <Route
          path='/users'
          render={() => (<Header>Account</Header>)}
        />
      </Switch>
    </div>
  );
}

export default QualHeader;